(() => {
  const cf = document.getElementById('collection-filters');
  if (!cf) return;

  const GROUP_ATTR = { thc_combos: 'thcCombo', vibe: 'effect', flavor: 'title', size: 'size' };
  const FILTER_GROUPS = Object.keys(GROUP_ATTR);
  const activeFilters = {};

  function normalizeValue(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function cardValues(card, attr) {
    const raw = card.dataset[attr] || '';
    if (attr === 'tags') {
      return raw.split('|').reduce((vals, tag) => {
        const normalized = normalizeValue(tag);
        if (normalized) vals.add(normalized);
        return vals;
      }, new Set());
    }
    if (attr === 'effect') {
      const effectText = card.querySelector('.product-card-effect')?.textContent.replace(/^for\s+/i, '') || '';
      return new Set([normalizeValue(raw), normalizeValue(effectText)].filter(Boolean));
    }
    if (attr === 'size') {
      return new Set([normalizeValue(cardSizeLabel(card))].filter(Boolean));
    }
    return new Set([normalizeValue(raw)].filter(Boolean));
  }

  function optionValue(opt) {
    return normalizeValue(opt.dataset.tag ?? opt.dataset.effect);
  }

  function optionMatchesCard(opt, group, card) {
    const attr = GROUP_ATTR[group];
    if (!attr) return true;
    const val = optionValue(opt);
    if (!val) return false;
    const vals = cardValues(card, attr);
    return attr === 'title'
      ? [...vals].some(cardVal => cardVal.includes(val))
      : vals.has(val);
  }

  function cardMatchesSelection(card, group, selected) {
    const attr = GROUP_ATTR[group];
    if (!attr) return true;
    const vals = cardValues(card, attr);
    return [...selected].some(sel => attr === 'title'
      ? [...vals].some(cardVal => cardVal.includes(sel))
      : vals.has(sel));
  }

  function cardMatchesActiveFilters(card, excludedGroup) {
    return Object.entries(activeFilters).every(([group, selected]) => {
      if (group === excludedGroup || selected.size === 0) return true;
      return cardMatchesSelection(card, group, selected);
    });
  }

  function matchingCardCount(filters) {
    return [...document.querySelectorAll('.product-grid .product-card-container')].filter(card => (
      Object.entries(filters).every(([group, selected]) => {
        if (selected.size === 0) return true;
        return cardMatchesSelection(card, group, selected);
      })
    )).length;
  }

  function nextFilters(group, val, wasSelected) {
    const filters = {};
    FILTER_GROUPS.forEach(filterGroup => {
      filters[filterGroup] = new Set(activeFilters[filterGroup] || []);
    });

    if (!filters[group]) filters[group] = new Set();
    filters[group].clear();
    if (!wasSelected) filters[group].add(val);

    return filters;
  }

  function optionButton(type, value, label) {
    const btn = document.createElement('button');
    btn.className = 'cf__opt';
    btn.type = 'button';
    btn.dataset[type] = value;
    btn.textContent = label;
    return btn;
  }

  function titleizeHandle(handle) {
    return String(handle || '')
      .split('-')
      .filter(Boolean)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  function cardEffectLabel(card) {
    const label = card.querySelector('.product-card-effect')?.textContent
      .replace(/^for\s+/i, '')
      .trim();
    if (label && !/^coming soon$/i.test(label)) return label;
    return titleizeHandle(card.dataset.effect);
  }

  function cardFlavorLabel(card) {
    const title = card.querySelector('.product-card-title')?.textContent.trim() || '';
    if (!cardSizeLabel(card) && !/\(\s*\d+mg/i.test(title)) return '';
    if (/\btin\b/i.test(title)) return '';
    return title
      .replace(/\s*\([^)]*\).*$/, '')
      .replace(/\s+(mini|value pack|discovery pack)$/i, '')
      .trim();
  }

  function cardSizeLabel(card) {
    const title = card.querySelector('.product-card-title')?.textContent.trim() || '';
    if (/\bvalue pack\b/i.test(title)) return 'Value Packs';
    if (/\bmini\b/i.test(title)) return 'Minis';
    if (/\bdiscovery pack\b/i.test(title)) return 'Discovery Packs';
    return '';
  }

  function buildDynamicOptions() {
    const cards = [...document.querySelectorAll('.product-grid .product-card-container')];
    if (!cards.length) return;

    [
      { group: 'vibe', attr: 'effect', dataType: 'effect', getLabel: cardEffectLabel },
      { group: 'flavor', attr: 'title', dataType: 'tag', getLabel: cardFlavorLabel },
      { group: 'size', attr: 'size', dataType: 'tag', getLabel: cardSizeLabel }
    ].forEach(({ group, attr, dataType, getLabel }) => {
      cf.querySelectorAll(`.cf__dd[data-group="${group}"] .cf__drop`).forEach(drop => {
        const seen = new Set();
        const opts = [];

        cards.forEach(card => {
          const label = getLabel(card);
          const val = attr === 'effect'
            ? [...cardValues(card, attr)][0]
            : normalizeValue(label);

          if (!label || !val || seen.has(val)) return;
          seen.add(val);
          opts.push(optionButton(dataType, val, label));
        });

        if (opts.length) {
          const navLinks = [...drop.querySelectorAll('a.cf__opt')];
          drop.replaceChildren(...opts, ...navLinks);
        }
      });
    });
  }

  function syncOptionAvailability() {
    const cards = [...document.querySelectorAll('.product-grid .product-card-container')];
    if (!cards.length) return;

    cf.querySelectorAll('.cf__dd').forEach(dd => {
      const group = dd.dataset.group;
      if (!GROUP_ATTR[group]) return;

      dd.querySelectorAll('.cf__opt[data-tag], .cf__opt[data-effect]').forEach(opt => {
        const unavailable = !cards.some(card => (
          cardMatchesActiveFilters(card, group) && optionMatchesCard(opt, group, card)
        ));
        opt.hidden = unavailable;
        opt.disabled = unavailable;
      });

      const hasOptions = !!dd.querySelector(
        '.cf__opt[data-tag]:not([hidden]), .cf__opt[data-effect]:not([hidden]), a.cf__opt'
      );
      dd.hidden = !hasOptions;
    });
  }

  // ── Filtering ──────────────────────────────────────────
  function applyFilters() {
    const cards = document.querySelectorAll('.product-grid .product-card-container');
    const activeGroups = Object.entries(activeFilters).filter(([, s]) => s.size > 0);

    cards.forEach(card => {
      const wrapper = card.closest('.product-card-wrapper') || card;
      if (!activeGroups.length) {
        card.style.display = '';
        wrapper.style.display = '';
        return;
      }
      const visible = activeGroups.every(([group, selected]) => {
        const attr = GROUP_ATTR[group];
        if (!attr) return true;
        const vals = cardValues(card, attr);
        return [...selected].some(sel => attr === 'title'
          ? [...vals].some(cardVal => cardVal.includes(sel))
          : vals.has(sel));
      });
      wrapper.style.display = visible ? '' : 'none';
    });

    syncOptionAvailability();
  }

  // ── Dropdown helpers ───────────────────────────────────
  function setDrop(ddEl, open) {
    const btn = ddEl.querySelector(':scope > .cf__pill');
    const panel = ddEl.querySelector(':scope > .cf__drop');
    if (!btn || !panel) return;
    ddEl.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  }

  function closeAll(except) {
    cf.querySelectorAll('.cf__dd').forEach(dd => { if (dd !== except) setDrop(dd, false); });
  }

  function pillLabelDefault(group) {
    return { thc_combos: 'THC Combos', vibe: 'Vibe', flavor: 'Flavors', size: 'Size', dosage: 'Dosage' }[group] || group;
  }

  function hasActiveFilters() {
    return Object.values(activeFilters).some(selected => selected.size > 0);
  }

  function syncResetState() {
    cf.querySelectorAll('.cf__reset').forEach(reset => {
      reset.hidden = !hasActiveFilters();
    });
  }

  function syncGroupState(group, selectedVal, selectedLabel = selectedVal) {
    const hasSelection = activeFilters[group]?.size > 0;
    cf.querySelectorAll(`.cf__dd[data-group="${group}"]`).forEach(dd => {
      dd.classList.toggle('has-selection', hasSelection);
      const pillText = dd.querySelector('.cf__pill-text');
      if (pillText) {
        pillText.textContent = hasSelection ? selectedLabel : pillLabelDefault(group);
      }
      // Sync aria-selected on all opts
      dd.querySelectorAll('.cf__opt[data-tag], .cf__opt[data-effect]').forEach(o => {
        const v = optionValue(o);
        o.setAttribute('aria-selected', String(hasSelection && v === selectedVal));
      });
    });
    syncResetState();
  }

  function resetFilters() {
    FILTER_GROUPS.forEach(group => {
      if (!activeFilters[group]) activeFilters[group] = new Set();
      activeFilters[group].clear();
      syncGroupState(group, '');
    });
    closeAll();
    applyFilters();
  }

  function syncDropdownWidths() {
    cf.querySelectorAll('.cf__dd').forEach(dd => {
      const pill = dd.querySelector(':scope > .cf__pill');
      const drop = dd.querySelector(':scope > .cf__drop');
      if (!pill || !drop) return;
      drop.style.visibility = 'hidden';
      drop.hidden = false;
      const w = drop.offsetWidth;
      drop.hidden = true;
      drop.style.visibility = '';
      if (w > pill.offsetWidth) pill.style.minWidth = `${w}px`;
    });
  }

  // ── Single delegated click listener on the CF container ──
  cf.addEventListener('click', e => {
    // ── Reset click ──
    const reset = e.target.closest('.cf__reset');
    if (reset) {
      e.stopPropagation();
      resetFilters();
      return;
    }

    // ── Option click ──
    const opt = e.target.closest('.cf__opt[data-tag], .cf__opt[data-effect]');
    if (opt) {
      e.stopPropagation();
      if (opt.hidden || opt.disabled) return;
      const dd = opt.closest('.cf__dd');
      const group = dd?.dataset.group;
      if (!group || group === 'dosage') return; // dosage uses <a> links, no JS needed

      const val = optionValue(opt);
      if (!val) return;

      if (!activeFilters[group]) activeFilters[group] = new Set();
      const wasSelected = activeFilters[group].has(val);
      const filters = nextFilters(group, val, wasSelected);

      if (!wasSelected && matchingCardCount(filters) === 0) {
        setDrop(dd, false);
        if (opt.closest('#cf-mob-panel')) closeMobile();
        return;
      }

      activeFilters[group] = filters[group];

      syncGroupState(group, wasSelected ? '' : val, wasSelected ? '' : opt.textContent.trim());
      setDrop(dd, false);
      applyFilters();
      if (opt.closest('#cf-mob-panel')) closeMobile();
      return;
    }

    // ── Pill click ──
    const pill = e.target.closest('.cf__pill');
    if (pill) {
      e.stopPropagation();
      const dd = pill.closest('.cf__dd');
      if (!dd) return;
      const isOpen = pill.getAttribute('aria-expanded') === 'true';

      // Scope: close siblings within the same row/panel
      const scope = dd.closest('.cf__mob-pills, .cf__pills-row');
      if (scope) {
        scope.querySelectorAll('.cf__dd').forEach(sibling => {
          if (sibling !== dd) setDrop(sibling, false);
        });
      }

      setDrop(dd, !isOpen);
      return;
    }

    // ── Click on backdrop or anywhere outside → close all ──
    closeAll();
  });

  // Close on outside click
  document.addEventListener('click', closeAll);

  // ── Mobile panel ───────────────────────────────────────
  const mobBtn = document.getElementById('cf-mob-btn');
  const mobPanel = document.getElementById('cf-mob-panel');
  const backdrop = document.getElementById('cf-backdrop');

  function openMobile() {
    if (!mobPanel || !mobBtn) return;
    mobPanel.hidden = false;
    if (backdrop) backdrop.hidden = false;
    mobBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobile() {
    if (!mobPanel || !mobBtn) return;
    mobPanel.hidden = true;
    if (backdrop) backdrop.hidden = true;
    mobBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    cf.querySelectorAll('.cf__mob-pills .cf__dd').forEach(dd => setDrop(dd, false));
  }

  if (mobBtn) {
    mobBtn.addEventListener('click', e => {
      e.stopPropagation();
      mobBtn.getAttribute('aria-expanded') === 'true' ? closeMobile() : openMobile();
    });
  }
  if (backdrop) {
    backdrop.addEventListener('click', closeMobile);
  }

  buildDynamicOptions();
  syncOptionAvailability();
  syncDropdownWidths();
})();
